'use client'
import { isValidEmail } from '@utils/common'
import { BodyText, DetailText } from 'design-configuration/components'

import { CheckIcon } from 'design-configuration/components'
import { motion } from 'motion/react'
import { useState } from 'react'

export default function NewsletterSignup(): React.ReactElement {
  const [email, setEmail] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [emailAlreadySubmitted, setEmailAlreadySubmitted] = useState(false)

  const submitEmail = async () => {
    if (!email || !isValidEmail(email)) {
      setError('Please enter a valid email')
      return
    }
    if (emailAlreadySubmitted) {
      setError('You have already submitted your email')
      return
    }
    try {
      setError(null)

      const res = await fetch('/api/add-to-email-octopus', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          email,
          tag: 'curated'
        })
      })
      if (res.status === 200) {
        setEmailAlreadySubmitted(true)
      } else {
        setError('Error submitting email')
      }
      return
    } catch (e) {
      console.error('Error submitting email', e.message)
      if (e.response?.status === 409) {
        setError('Error: Email has already been submitted')
      } else {
        setError('Error submitting email')
      }
    }
  }
  return (
    <>
      <div className="flex w-full max-w-[466px] flex-row">
        <input
          type="email"
          placeholder="Get updates in your inbox"
          className={`px-sm py-xs rounded-l-xs border-primary-inverted-10 w-full border-b border-l border-t bg-transparent focus-visible:outline-none ${
            email ? 'text-on-surface-inverted' : 'text-on-surface-inverted-variant'
          }`}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <button
          className="bg-primary-inverted-10 hover:bg-primary-inverted-20 text-on-primary-inverted-alpha w-[120px] overflow-hidden disabled:cursor-not-allowed disabled:opacity-50"
          style={{
            borderRadius: '0px var(--tiny-radius, 2px) var(--tiny-radius, 2px) 0px'
          }}
          disabled={!email || !isValidEmail(email) || emailAlreadySubmitted}
          onClick={async () => {
            await submitEmail()
          }}
        >
          <motion.div
            initial={false}
            animate={{
              translateY: emailAlreadySubmitted ? -30 : 8
            }}
            className="flex w-full flex-row"
          >
            <BodyText className="w-full">Subscribe</BodyText>
          </motion.div>
          <motion.div
            initial={false}
            animate={{
              translateY: emailAlreadySubmitted ? -11 : 15
            }}
            className="flex items-center justify-center"
          >
            <CheckIcon className="fill-on-primary-inverted-alpha" />
          </motion.div>
        </button>
      </div>
      {error ? <DetailText className="text-error-inverted pt-2xs">{error}</DetailText> : null}
    </>
  )
}
